import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { iconList } from './iconList.js';
import { Box } from '../Box/index.js';

const sizeMap = {
  small: '12px',
  medium: '16px',
  large: '24px',
  xlarge: '38px'
};
/**
 * Icon is used to render svg icons.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/icon#usage)
 * - [Props](https://blockparty.endpoint.com/components/icon#props)
 * <br />
 *
 */
const Icon = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    color = 'currentColor',
    focusable = false,
    name,
    size = '1em',
    viewBox = '0 0 24 24',
    dataTestId = 'icon',
    ...rest
  } = _ref;
  // Fallback for incorrect icon name
  const iconFallback = iconList.Information;
  const icon = !iconList[name] ? iconFallback : iconList[name];
  const hasLabel = rest['aria-label'] || rest['aria-labelledby'];
  const iconRole = hasLabel ? 'img' : 'presentation';
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    as: "svg",
    color: color,
    "data-test-id": dataTestId,
    fill: "currentColor"
    // @ts-ignore - focusable is not extended from BoxProps
    ,
    focusable: focusable,
    role: iconRole
    // @ts-ignore - revisit mapping to include non-defined string values
    ,
    size: !sizeMap[size] ? size : sizeMap[size],
    verticalAlign: "middle",
    viewBox: viewBox
  }, rest), icon);
});

export { Icon };
